import { render, staticRenderFns } from "./DialogMercadoPago.vue?vue&type=template&id=46e6d758"
import script from "./DialogMercadoPago.vue?vue&type=script&lang=js"
export * from "./DialogMercadoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports